export class ComponentForm {
  campi:any[]=[]
    cm_id: number = 0;
    cm_state: number = 0;
    cm_module_name: string = '';
    cm_description: string = '';
    cm_settings: string = '';
    cm_wf_id:number=0;
    title='';
    row: number = 1;
    column: number = 1;
    type: number = 1;
  }